(() => {
  if (window.unborioWonderHouseLoaded) return;
  window.unborioWonderHouseLoaded = true;
  const houses = new Map();
  const cabinets = new Map();
  const notes = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const overlayOpen = () => document.documentElement.dataset.havenDialogOpen === 'true';
  function createGoldStream(root, canMove) {
    const svg = root.querySelector('[data-uh-gold-stream]');
    const tail = svg?.querySelector('[data-uh-stream-tail]');
    const ribbon = svg?.querySelector('[data-uh-stream-ribbon]');
    const glow = svg?.querySelector('[data-uh-stream-glow]');
    const fold = svg?.querySelector('[data-uh-stream-fold]');
    const head = svg?.querySelector('[data-uh-stream-head]');
    const gradient = svg?.querySelector('[data-uh-stream-gradient]');
    const bloom = svg?.querySelector('[data-uh-stream-bloom]');
    const ring = svg?.querySelector('[data-uh-stream-ring]');
    if (!svg || !tail || !ribbon || !glow || !fold || !head || !gradient) return { setRunning() {}, seek: () => 0, destroy() {} };
    const waypoints = [[12,60],[20,28],[48,12],[76,23],[85,50],[63,70],[36,73],[25,56],[49,37],[77,40],[91,69],[74,85],[45,87],[18,75]].map(p => [p[0] * 15.36, p[1] * 10.24]);
    const period = 23000;
    let clock = 0;
    let frame = 0;
    let last = 0;
    let running = false;
    let route;
    let landing;
    let pulse = -Infinity;
    let point = [...waypoints[0]];
    let previous = [point[0] - 1, point[1] + 1];
    let history = [];
    function state(value) { svg.dataset.uhStreamState = value; }
    function orbitAt(value) {
      const phase = ((value % period) + period) % period / period * waypoints.length;
      const i = Math.floor(phase), t = phase - i, t2 = t * t, t3 = t2 * t;
      const at = n => waypoints[(n + waypoints.length) % waypoints.length];
      const a = at(i - 1), b = at(i), c = at(i + 1), d = at(i + 2);
      return [0,1].map(axis => .5 * (2 * b[axis] + (-a[axis] + c[axis]) * t + (2 * a[axis] - 5 * b[axis] + 4 * c[axis] - d[axis]) * t2 + (-a[axis] + 3 * b[axis] - 3 * c[axis] + d[axis]) * t3));
    }
    const bounded = p => [Math.max(40, Math.min(1496, p[0])), Math.max(40, Math.min(984, p[1]))];
    function makeRoute(destination, duration, now, kind) {
      const dx = destination[0] - point[0], dy = destination[1] - point[1];
      const distance = Math.max(1, Math.hypot(dx, dy));
      const vx = point[0] - previous[0], vy = point[1] - previous[1];
      const speed = Math.hypot(vx, vy);
      const tangent = speed > .05 ? [vx / speed, vy / speed] : [dx / distance, dy / distance];
      const reach = Math.min(170, Math.max(45, distance * .32));
      const bend = Math.min(120, distance * .17);
      route = { start: [...point], end: destination, c1: bounded([point[0] + tangent[0] * reach, point[1] + tangent[1] * reach]), c2: bounded([destination[0] - dx * .16 - dy / distance * bend, destination[1] - dy * .16 + dx / distance * bend]), began: now, duration, kind };
      landing = undefined;
      state(kind);
    }
    function returnToOrbit(now) {
      let nearest = clock, distance = Infinity;
      for (let i = 0; i < 96; i++) {
        const phase = i / 96 * period;
        const candidate = orbitAt(phase);
        const gap = Math.hypot(candidate[0] - point[0], candidate[1] - point[1]);
        if (gap < distance) { nearest = phase; distance = gap; }
      }
      const duration = 1150;
      makeRoute(orbitAt(nearest + duration), duration, now, 'returning');
      route.clock = nearest + duration;
    }
    function seedRibbon() {
      const points = [[...point]];
      let length = 0;
      for (let i = 1; i <= 180 && length < 720; i++) {
        const p = orbitAt(clock - i * 50);
        const next = points[points.length - 1];
        length += Math.hypot(p[0] - next[0], p[1] - next[1]);
        points.push(p);
      }
      history = points.reverse().map(p => ({ p }));
    }
    function draw(now) {
      const latest = history[history.length - 1]?.p;
      if (!latest || Math.hypot(latest[0] - point[0], latest[1] - point[1]) > 1.5) history.push({ p: [...point] });
      let length = 0, start = Math.max(0, history.length - 160);
      for (let i = history.length - 1; i > start; i--) {
        const current = history[i].p, before = history[i - 1].p;
        const segment = Math.hypot(current[0] - before[0], current[1] - before[1]);
        if (length + segment > 720) {
          const t = (720 - length) / segment;
          history[i - 1] = { p: [current[0] + (before[0] - current[0]) * t, current[1] + (before[1] - current[1]) * t] };
          start = i - 1;
          break;
        }
        length += segment;
      }
      history = history.slice(start);
      const oldest = history[0].p;
      const coords = p => p.map(v => v.toFixed(1)).join(' ');
      const distances = [0];
      for (let i = 1; i < history.length; i++) {
        const a = history[i - 1].p, b = history[i].p;
        distances.push(distances[i - 1] + Math.hypot(b[0] - a[0], b[1] - a[1]));
      }
      const total = distances[distances.length - 1];
      const samples = [];
      let segment = 1;
      for (let i = 0; i <= 48; i++) {
        const distance = total * i / 48;
        while (segment < history.length - 1 && distances[segment] < distance) segment++;
        const a = history[Math.max(0, segment - 1)].p, b = history[Math.min(segment, history.length - 1)].p;
        const t = (distance - (distances[segment - 1] || 0)) / Math.max(.001, (distances[segment] || 0) - (distances[segment - 1] || 0));
        samples.push([a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t]);
      }
      function smooth(points) {
        let path = 'M ' + coords(points[0]);
        for (let i = 1; i < points.length - 1; i++) {
          const p = points[i], next = points[i + 1];
          path += ' Q ' + coords(p) + ' ' + coords([(p[0] + next[0]) / 2, (p[1] + next[1]) / 2]);
        }
        return path + ' L ' + coords(points[points.length - 1]);
      }
      const edges = samples.map((p, i) => {
        const before = samples[Math.max(0, i - 1)], after = samples[Math.min(samples.length - 1, i + 1)];
        const dx = after[0] - before[0], dy = after[1] - before[1];
        const magnitude = Math.max(.001, Math.hypot(dx, dy));
        const u = i / 48, taper = Math.pow(Math.sin(Math.PI * u), .72);
        const width = 21 * taper * (.78 + .22 * Math.cos(u * Math.PI * 2.6 - now * .00075));
        const drift = 5 * taper * Math.sin(u * Math.PI * 3 - now * .00055);
        return { p: [p[0] - dy / magnitude * drift, p[1] + dx / magnitude * drift], n: [-dy / magnitude, dx / magnitude], width, u };
      });
      function band(scale, offset) {
        const side = direction => edges.map(e => {
          const distance = e.width * (direction * scale + offset);
          return [e.p[0] + e.n[0] * distance, e.p[1] + e.n[1] * distance];
        });
        const left = side(1), right = side(-1).reverse();
        return smooth(left) + ' ' + smooth(right).replace(/^M /, 'L ') + ' Z';
      }
      ribbon.setAttribute('d', band(1, 0));
      glow.setAttribute('d', band(1.85, 0));
      fold.setAttribute('d', band(.22, -.28));
      tail.setAttribute('d', smooth(edges.map(e => [e.p[0] + e.n[0] * e.width * .35, e.p[1] + e.n[1] * e.width * .35])));
      gradient.setAttribute('x1', oldest[0].toFixed(1));
      gradient.setAttribute('y1', oldest[1].toFixed(1));
      gradient.setAttribute('x2', (point[0] + .1).toFixed(1));
      gradient.setAttribute('y2', point[1].toFixed(1));
      head.setAttribute('transform', 'translate(' + coords(point) + ')');
      const progress = Math.min(1, (now - pulse) / 850);
      if (bloom) bloom.setAttribute('opacity', progress < 1 ? ((1 - progress) * .48).toFixed(3) : '0');
      ring?.setAttribute('r', (14 + progress * 48).toFixed(1));
    }
    function tick(now) {
      frame = 0;
      if (!running || !canMove()) return;
      const delta = last ? Math.min(50, now - last) : 0;
      if (last && now - last < 28) { frame = requestAnimationFrame(tick); return; }
      last = now;
      previous = [...point];
      if (route) {
        const current = route;
        const progress = Math.min(1, (now - current.began) / current.duration);
        const t = progress * progress * (3 - 2 * progress), q = 1 - t;
        point = [0,1].map(axis => q * q * q * current.start[axis] + 3 * q * q * t * current.c1[axis] + 3 * q * t * t * current.c2[axis] + t * t * t * current.end[axis]);
        if (current.approach && progress >= .3) { const approach = current.approach; current.approach = undefined; approach(Math.max(80, current.duration * (1 - progress))); }
        if (progress === 1) {
          route = undefined;
          if (current.kind === 'flying') {
            landing = { center: [...point], began: now };
            pulse = now;
            bloom?.setAttribute('transform', 'translate(' + point.join(' ') + ')');
            state('landing');
            current.arrive?.();
          } else { clock = current.clock; state('orbit'); }
        }
      } else if (landing) {
        const progress = Math.min(1, (now - landing.began) / 560);
        point = [landing.center[0] + Math.sin(progress * Math.PI * 2) * 10, landing.center[1] - Math.sin(progress * Math.PI) * 9];
        if (progress === 1) returnToOrbit(now);
      } else { clock += delta; point = orbitAt(clock); }
      draw(now);
      frame = requestAnimationFrame(tick);
    }
    return {
      setRunning(enabled) {
        if (enabled === running) return;
        running = enabled;
        if (frame) cancelAnimationFrame(frame);
        frame = 0;
        last = 0;
        if (enabled) {
          svg.removeAttribute('hidden');
          if (history.length < 2) seedRibbon();
          if (route || landing) returnToOrbit(performance.now());
          else state('orbit');
          draw(performance.now());
          frame = requestAnimationFrame(tick);
        } else { state('paused'); bloom?.setAttribute('opacity', '0'); }
      },
      seek(destination, room, approach, arrive) {
        if (!running || !canMove()) return 0;
        const end = [destination[0] * 15.36, destination[1] * 10.24];
        const duration = Math.min(1180, 700 + Math.hypot(end[0] - point[0], end[1] - point[1]) * .35);
        makeRoute(end, duration, performance.now(), 'flying');
        route.approach = approach;
        route.arrive = arrive;
        svg.dataset.uhStreamRoom = String(room);
        return duration;
      },
      destroy() { running = false; if (frame) cancelAnimationFrame(frame); frame = 0; history = []; route = landing = undefined; }
    };
  }
  function initHouse(root) {
    if (houses.has(root)) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    root.dataset.uhEnhanced = '';
    const tabs = [...root.querySelectorAll('[data-uh-room]')];
    const hotspots = [...root.querySelectorAll('[data-uh-hotspot]')];
    const panels = [...root.querySelectorAll('[data-uh-panel]')];
    const explore = root.querySelector('[data-uh-explore]');
    const roomPicker = root.querySelector('.uh-room-tabs');
    const scene = root.querySelector('[data-uh-scene]');
    const dial = root.querySelector('[data-uh-daylight]');
    const time = root.querySelector('[data-uh-time]');
    const motion = root.querySelector('[data-uh-motion]');
    const motionLabel = root.querySelector('[data-uh-motion-label]');
    const camera = root.querySelector('[data-uh-camera]');
    const look = root.querySelector('[data-uh-look]');
    const lookHint = root.querySelector('[data-uh-look-hint]');
    const reveal = root.querySelector('[data-uh-room-reveal]');
    const houseImage = root.querySelector('.uh-house-image > img');
    const lightImage = reveal?.querySelector('[data-uh-light-image]');
    const lightShape = reveal?.querySelector('[data-uh-light-shape]');
    const areas = [...root.querySelectorAll('[data-uh-area]')];
    const outlines = [
      [[2,41],[10,36],[26,43],[40,47],[40,65],[33,75],[15,70],[2,67]],
      [[9,15],[22,4],[47,10],[49,12],[49,37],[40,47],[20,40],[9,37]],
      [[48,11],[53,3],[71,8],[73,12],[72,35],[66,41],[49,35],[49,22]],
      [[72,14],[76,7],[90,12],[92,25],[89,35],[83,40],[72,36],[72,25]],
      [[69,42],[82,37],[94,33],[98,57],[97,78],[83,91],[66,85],[69,74]],
      [[42,66],[47,65],[52,67],[53,72],[51,76],[45,77],[41,74],[40,70]],
      [[51,44],[56,43],[66,48],[68,62],[66,76],[58,81],[51,76],[51,60]]
    ];
    const anchors = [[24,58],[29,31],[64,24],[82,24],[80,70],[47,70],[62,70]];
    const regions = hotspots.map((hotspot,index) => {
      const anchor = anchors[index] || [50,50];
      const outline = outlines[index] || outlines[0];
      const configuredX = parseFloat(hotspot.style.getPropertyValue('--x'));
      const configuredY = parseFloat(hotspot.style.getPropertyValue('--y'));
      const x = Number.isFinite(configuredX) ? configuredX : anchor[0];
      const y = Number.isFinite(configuredY) ? configuredY : anchor[1];
      const width = Math.max(...outline.map(p=>p[0])) - Math.min(...outline.map(p=>p[0]));
      const height = Math.max(...outline.map(p=>p[1])) - Math.min(...outline.map(p=>p[1]));
      const scaleX = Number(hotspot.dataset.lightWidth) > 0 ? Number(hotspot.dataset.lightWidth) * 2 / width : 1;
      const scaleY = Number(hotspot.dataset.lightHeight) > 0 ? Number(hotspot.dataset.lightHeight) * 2 / height : 1;
      return outline.map(p=>[Math.max(0,Math.min(100,x+(p[0]-anchor[0])*scaleX)),Math.max(0,Math.min(100,y+(p[1]-anchor[1])*scaleY))]);
    });
    function syncLightImage() {
      if (lightImage && houseImage) lightImage.setAttribute('href',houseImage.currentSrc || houseImage.src);
    }
    if (houseImage && lightImage) {
      houseImage.addEventListener('load',syncLightImage,options);
      syncLightImage();
    }
    areas.forEach((area,index) => {
      if (!regions[index]) return;
      area.style.clipPath = 'polygon(' + regions[index].map(p=>p[0]+'% '+p[1]+'%').join(',') + ')';
      area.hidden = false;
    });
    let active = 0;
    let scrollFrame = 0;
    let pointerFrame = 0;
    let motionOn = !reduced.matches;
    let inView = true;
    let observer;
    let lookOn = false;
    let viewX = 0;
    let viewY = 0;
    let drag;
    let lightFrame = 0;
    let lightPoints;
    let lightTarget;
    const canMove = () => motionOn && !reduced.matches && inView && !document.hidden && !overlayOpen();
    const stream = createGoldStream(root, canMove);
    const guideTargets = hotspots.map((hotspot, index) => {
      const x = parseFloat(hotspot.style.getPropertyValue('--x'));
      const y = parseFloat(hotspot.style.getPropertyValue('--y'));
      return [Number.isFinite(x) ? x : anchors[index]?.[0] || 50, Math.min(96, (Number.isFinite(y) ? y : anchors[index]?.[1] || 50) + 3.2)];
    });
    root.style.setProperty('--uh-room-view', 'uh-room-' + root.id.replace(/[^a-zA-Z0-9-]/g, ''));
    function cameraView(x, y) {
      viewX = Math.max(-12, Math.min(12, x));
      viewY = Math.max(-6, Math.min(6, y));
      scene?.style.setProperty('--mx', viewX.toFixed(2) + 'deg');
      scene?.style.setProperty('--my', viewY.toFixed(2) + 'deg');
    }
    function setLook(enabled) {
      lookOn = enabled;
      look?.setAttribute('aria-pressed', String(enabled));
      if (lookHint) lookHint.hidden = !enabled;
      root.classList.toggle('uh-look-active', enabled);
      if (pointerFrame) cancelAnimationFrame(pointerFrame);
      pointerFrame = 0;
      if (!enabled) cameraView(0, 0);
    }
    if (camera && scene) {
      camera.hidden = false;
      look?.addEventListener('click', () => setLook(!lookOn), options);
      look?.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') { setLook(false); return; }
        setLook(true);
        cameraView(viewX + (event.key === 'ArrowLeft' ? -3 : event.key === 'ArrowRight' ? 3 : 0), viewY + (event.key === 'ArrowUp' ? 2 : event.key === 'ArrowDown' ? -2 : 0));
      }, options);
      camera.querySelectorAll('[data-uh-turn]').forEach(button => button.addEventListener('click', () => {
        setLook(true);
        cameraView(viewX + Number(button.dataset.uhTurn) * 6, viewY);
      }, options));
      camera.querySelector('[data-uh-reset]')?.addEventListener('click', () => setLook(false), options);
    }
    function syncMotion() {
      root.classList.toggle('uh-motion-paused', !motionOn || reduced.matches || !inView || document.hidden || overlayOpen());
      motion?.setAttribute('aria-pressed', String(motionOn));
      motion?.setAttribute('aria-label', motionOn ? motion.dataset.pause : motion.dataset.play);
      if (motionLabel) motionLabel.textContent = motionOn ? motion.dataset.on : motion.dataset.off;
      if ((!motionOn || reduced.matches) && scene) {
        if (pointerFrame) cancelAnimationFrame(pointerFrame);
        pointerFrame = 0;
        if (!lookOn) cameraView(0, 0);
        scene.style.setProperty('--float', '0px');
      }
      stream.setRunning(canMove());
      if (!canMove()) {
        settleLight();
        root.classList.remove('uh-light-seeking', 'uh-light-awaiting');
      }
    }
    if (motion) {
      motion.hidden = false;
      motion.addEventListener('click', () => { motionOn = !motionOn; syncMotion(); updateScroll(); }, options);
    }
    document.addEventListener('visibilitychange', syncMotion, options);
    document.addEventListener('haven:overlay', syncMotion, options);
    reduced.addEventListener('change', () => { motionOn = !reduced.matches; syncMotion(); updateScroll(); }, options);
    if (scene && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        inView = entries[0].isIntersecting;
        syncMotion();
      }, { threshold: .08 });
      observer.observe(scene);
    }
    syncMotion();
    function moveToRoom() {
        const destination = window.innerWidth < 900 ? panels[active] : roomPicker;
        const bounds = destination?.getBoundingClientRect();
        if (bounds && (bounds.top < 100 || bounds.bottom > window.innerHeight - 50)) destination.scrollIntoView({ block: 'start', behavior: reduced.matches ? 'auto' : 'smooth' });
        if (window.innerWidth < 900) panels[active]?.focus({ preventScroll: true });
    }
    function paintLight(points) {
      lightPoints = points.map(p=>[p[0],p[1]]);
      lightShape?.setAttribute('points',points.map(p=>(p[0]*15.36).toFixed(2)+','+(p[1]*10.24).toFixed(2)).join(' '));
    }
    function settleLight() {
      if (lightFrame) cancelAnimationFrame(lightFrame);
      lightFrame = 0;
      root.classList.remove('uh-light-traveling');
      if (lightTarget) paintLight(lightTarget);
    }
    function lightRoom(index,animate = true, flightDuration) {
      const target = regions[index];
      if (!target || !scene) return;
      if (lightFrame) cancelAnimationFrame(lightFrame);
      lightFrame = 0;
      lightTarget = target;
      if (!animate || !lightPoints || !lightShape || !motionOn || reduced.matches || !inView || document.hidden || overlayOpen()) {
        settleLight();
        return;
      }
      const start = lightPoints.map(p=>[p[0],p[1]]);
      const center = points=>points.reduce((sum,p)=>[sum[0]+p[0]/points.length,sum[1]+p[1]/points.length],[0,0]);
      const origin = center(start), destination = center(target);
      const dx = destination[0]-origin[0],dy = destination[1]-origin[1];
      const distance = Math.hypot(dx,dy);
      if (distance < .05) { settleLight(); return; }
      const duration = flightDuration || Math.min(1150,760+distance*6);
      const curve = Math.min(2.5,distance*.07);
      const began = performance.now();
      root.classList.add('uh-light-traveling');
      const frame = now=>{
        const progress = Math.min(1,(now-began)/duration);
        const eased = progress*progress*progress*(progress*(progress*6-15)+10);
        const bend = Math.sin(Math.PI*progress)*curve;
        paintLight(start.map((p,i)=>[p[0]+(target[i][0]-p[0])*eased-dy/distance*bend,p[1]+(target[i][1]-p[1])*eased+dx/distance*bend]));
        if (progress < 1) lightFrame = requestAnimationFrame(frame);
        else settleLight();
      };
      lightFrame = requestAnimationFrame(frame);
    }
    function guideToRoom(index, wasFocused) {
      if (lightFrame) cancelAnimationFrame(lightFrame);
      lightFrame = 0;
      lightTarget = regions[index];
      root.classList.remove('uh-light-traveling');
      const duration = stream.seek(guideTargets[index], index, remaining => {
        root.classList.remove('uh-light-awaiting');
        lightRoom(index, wasFocused, remaining);
      }, () => root.classList.remove('uh-light-seeking'));
      if (duration) {
        root.classList.add('uh-light-seeking');
        if (!wasFocused) root.classList.add('uh-light-awaiting');
      } else {
        root.classList.remove('uh-light-seeking', 'uh-light-awaiting');
        lightRoom(index, false);
      }
    }
    function selectRoom(index, focus = false, scroll = false) {
      const wasFocused = root.classList.contains('uh-room-lit') && !root.classList.contains('uh-light-awaiting');
      const next = Math.max(0, Math.min(tabs.length - 1, index));
      root.classList.add('uh-room-lit');
      if (active === next && wasFocused) {
        guideToRoom(next, true);
        if (focus) tabs[active]?.focus({ preventScroll: true });
        if (scroll) moveToRoom();
        return;
      }
      active = next;
      tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===active));tab.tabIndex=i===active?0:-1;});
      hotspots.forEach((hotspot,i)=>hotspot.setAttribute('aria-pressed',String(i===active)));
      panels.forEach((panel,i)=>{panel.hidden=i!==active;});
      guideToRoom(active, wasFocused);
      if (motionOn && !reduced.matches) panels[active]?.animate([{opacity:.35,transform:'translateY(6px)'},{opacity:1,transform:'translateY(0)'}],{duration:340,easing:'cubic-bezier(.22,.65,.3,1)'});
      if (focus) tabs[active]?.focus({preventScroll:true});
      if (scroll) moveToRoom();
    }
    lightRoom(active,false);
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectRoom(index), options);
      tab.addEventListener('pointermove', event => {
        if (!finePointer.matches || reduced.matches || !motionOn) return;
        const rect = tab.getBoundingClientRect();
        tab.style.setProperty('--uh-tab-x', (event.clientX - rect.left).toFixed(1) + 'px');
        tab.style.setProperty('--uh-tab-y', (event.clientY - rect.top).toFixed(1) + 'px');
      }, options);
      tab.addEventListener('keydown', event => {
        let next = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        selectRoom(next, true);
      }, options);
    });
    hotspots.forEach((hotspot, index) => hotspot.addEventListener('click', () => selectRoom(index, false, true), options));
    areas.forEach((area,index)=>area.addEventListener('click',()=>selectRoom(index,false,true),options));
    root.querySelector('[data-uh-surprise]')?.addEventListener('click', () => {
      const offset = tabs.length > 1 ? 1 + Math.floor(Math.random() * (tabs.length - 1)) : 0;
      selectRoom((active + offset) % tabs.length, true, false);
    }, options);
    function setDaylight() {
      if (!dial || !scene) return;
      const value = Number(dial.value);
      const evening = Math.max(0, (value - 55) / 45);
      const sunrise = Math.max(0, (40 - value) / 40);
      const brightness = .92 - evening * .10;
      scene.style.setProperty('--bright', String(brightness));
      scene.style.setProperty('--focus-bright', String(Math.max(.45, brightness * .53)));
      scene.style.setProperty('--room-lit-bright', String(brightness + .16));
      scene.style.setProperty('--sat', String(.94 - evening * .04));
      scene.style.setProperty('--sepia', String(.03 + sunrise * .055 + evening * .10));
      scene.style.setProperty('--glow', String(.16 + evening * .48));
      scene.style.setProperty('--sky', evening > .25 ? 'rgba(174,183,155,.55)' : 'rgba(221,219,193,.5)');
      const label = value < 36 ? dial.dataset.morning : value < 68 ? dial.dataset.afternoon : dial.dataset.evening;
      if (time) time.textContent = label;
      dial.setAttribute('aria-valuetext', label);
    }
    dial?.addEventListener('input', setDaylight, options);
    setDaylight();
    scene?.addEventListener('pointerdown', event => {
      if (!lookOn || event.button !== 0 || event.target.closest('button, a, input')) return;
      drag = { id: event.pointerId, x: event.clientX, y: event.clientY, viewX, viewY };
      scene.setPointerCapture(event.pointerId);
      root.classList.add('uh-dragging');
    }, options);
    const endDrag = event => {
      if (!drag || event.pointerId !== drag.id) return;
      if (scene.hasPointerCapture(event.pointerId)) scene.releasePointerCapture(event.pointerId);
      drag = undefined;
      root.classList.remove('uh-dragging');
    };
    scene?.addEventListener('pointerup', endDrag, options);
    scene?.addEventListener('pointercancel', endDrag, options);
    scene?.addEventListener('lostpointercapture', endDrag, options);
    scene?.addEventListener('pointermove', event => {
      if (drag) {
        const rect = scene.getBoundingClientRect();
        cameraView(drag.viewX + (event.clientX - drag.x) / rect.width * 32, drag.viewY - (event.clientY - drag.y) / rect.height * 14);
        return;
      }
      if (lookOn || !motionOn || reduced.matches || !finePointer.matches || event.pointerType !== 'mouse') return;
      if (event.target.closest('[data-uh-hotspot],[data-uh-area]')) {
        if (pointerFrame) cancelAnimationFrame(pointerFrame);
        pointerFrame = 0;
        return;
      }
      if (pointerFrame) cancelAnimationFrame(pointerFrame);
      const rect = scene.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width - .5) * 6;
      const y = ((event.clientY - rect.top) / rect.height - .5) * -4;
      pointerFrame = requestAnimationFrame(() => {
        scene.style.setProperty('--mx', x.toFixed(2) + 'deg');
        scene.style.setProperty('--my', y.toFixed(2) + 'deg');
        pointerFrame = 0;
      });
    }, options);
    scene?.addEventListener('pointerleave', () => {
      if (lookOn) return;
      if (pointerFrame) cancelAnimationFrame(pointerFrame);
      pointerFrame = 0;
      scene.style.setProperty('--mx', '0deg');
      scene.style.setProperty('--my', '0deg');
    }, options);
    function updateScroll() {
      scrollFrame = 0;
      if (!explore || !scene) return;
      const rect = explore.getBoundingClientRect();
      root.classList.toggle('uh-exploring', rect.top < window.innerHeight * .65 && rect.bottom > 0);
      const movement = !motionOn || reduced.matches || !finePointer.matches ? 0 : Math.max(-8, Math.min(8, -root.getBoundingClientRect().top / 100));
      scene.style.setProperty('--float', movement.toFixed(2) + 'px');
    }
    const onScroll = () => { if (!scrollFrame) scrollFrame = requestAnimationFrame(updateScroll); };
    window.addEventListener('scroll', onScroll, { ...options, passive: true });
    window.addEventListener('resize', onScroll, options);
    updateScroll();
    houses.set(root, () => {
      controller.abort();
      observer?.disconnect();
      stream.destroy();
      if (lightFrame) cancelAnimationFrame(lightFrame);
      if (scrollFrame) cancelAnimationFrame(scrollFrame);
      if (pointerFrame) cancelAnimationFrame(pointerFrame);
      houses.delete(root);
    });
  }
  function initCabinet(root) {
    if (cabinets.has(root)) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const drawers = [...root.querySelectorAll('[data-uh-drawer]')];
    let frame = 0;
    let observer;
    let inView = false;
    root.dataset.uhCabinetEnhanced = '';
    const syncMotion = () => root.classList.toggle('uh-cabinet-motion-paused', reduced.matches || document.hidden || !inView || overlayOpen());
    document.addEventListener('visibilitychange', syncMotion, options);
    document.addEventListener('haven:overlay', syncMotion, options);
    reduced.addEventListener('change', syncMotion, options);
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; syncMotion(); }, { threshold: .04 });
      observer.observe(root);
    } else inView = true;
    syncMotion();
    drawers.forEach(drawer => {
      const front = drawer.querySelector('summary');
      front?.addEventListener('pointermove', event => {
        if (!finePointer.matches || reduced.matches || event.pointerType !== 'mouse') return;
        if (frame) cancelAnimationFrame(frame);
        const rect = front.getBoundingClientRect();
        const x = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width));
        const y = Math.max(0, Math.min(1, (event.clientY - rect.top) / rect.height));
        frame = requestAnimationFrame(() => {
          front.style.setProperty('--uh-drawer-x', (x * 100).toFixed(1) + '%');
          front.style.setProperty('--uh-drawer-y', (y * 100).toFixed(1) + '%');
          front.style.setProperty('--uh-peek-x', ((x - .5) * 8).toFixed(2) + 'px');
          frame = 0;
        });
      }, options);
      front?.addEventListener('pointerleave', () => {
        if (frame) cancelAnimationFrame(frame);
        frame = 0;
        front.style.setProperty('--uh-drawer-x', '50%');
        front.style.setProperty('--uh-drawer-y', '50%');
        front.style.setProperty('--uh-peek-x', '0px');
      }, options);
      const updateLabel = () => {
        const label = drawer.querySelector('[data-uh-drawer-label]');
        if (label) label.textContent = drawer.open ? label.dataset.open : label.dataset.closed;
      };
      drawer.addEventListener('toggle', () => {
        updateLabel();
        if (!drawer.open) return;
        drawers.forEach(other => { if (other !== drawer) other.open = false; });
      }, options);
      updateLabel();
    });
    cabinets.set(root, () => {
      controller.abort();
      observer?.disconnect();
      if (frame) cancelAnimationFrame(frame);
      cabinets.delete(root);
    });
  }
  function initFilm(root, options) {
    const video = root.querySelector('[data-uh-film-stage] video');
    const controls = root.querySelector('[data-uh-film-controls]');
    const play = root.querySelector('[data-uh-film-play]');
    const playLabel = root.querySelector('[data-uh-film-play-label]');
    const sound = root.querySelector('[data-uh-film-sound]');
    const soundLabel = root.querySelector('[data-uh-film-sound-label]');
    if (!video || !controls || !play) return () => {};
    let inView = false;
    const saveData = navigator.connection?.saveData === true;
    let wanted = !reduced.matches && !saveData;
    let observer;
    let disposed = false;
    video.muted = true;
    video.controls = false;
    controls.hidden = false;
    function updateControls() {
      const playing = !video.paused;
      play.setAttribute('aria-pressed', String(playing));
      play.setAttribute('aria-label', playing ? play.dataset.pause : play.dataset.play);
      if (playLabel) playLabel.textContent = playing ? play.dataset.pause : play.dataset.play;
      sound?.setAttribute('aria-pressed', String(!video.muted));
      sound?.setAttribute('aria-label', video.muted ? sound.dataset.unmute : sound.dataset.mute);
      if (soundLabel) soundLabel.textContent = video.muted ? sound.dataset.on : sound.dataset.off;
    }
    function sync() {
      if (disposed) return;
      if (wanted && inView && !document.hidden && !overlayOpen()) video.play().catch(updateControls);
      else video.pause();
      updateControls();
    }
    play.addEventListener('click', () => { wanted = video.paused; sync(); }, options);
    sound?.addEventListener('click', () => {
      video.muted = !video.muted;
      if (!video.muted) { wanted = true; sync(); }
      updateControls();
    }, options);
    ['play', 'pause', 'volumechange', 'ended'].forEach(event => video.addEventListener(event, updateControls, options));
    document.addEventListener('visibilitychange', sync, options);
    document.addEventListener('haven:overlay', sync, options);
    reduced.addEventListener('change', () => { wanted = !reduced.matches && !saveData; sync(); }, options);
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => { inView = entries[0].isIntersecting && entries[0].intersectionRatio >= .15; sync(); }, { threshold: .15 });
      observer.observe(video);
    } else { inView = true; sync(); }
    updateControls();
    return () => { disposed = true; observer?.disconnect(); video.pause(); };
  }
  function initNote(root) {
    if (notes.has(root)) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const stopFilm = initFilm(root, options);
    const pick = root.querySelector('[data-uh-note-pick]');
    const pickLabel = root.querySelector('[data-uh-note-pick-label]');
    const find = root.querySelector('[data-uh-note-find]');
    const link = root.querySelector('[data-uh-note-link]');
    const label = root.querySelector('[data-uh-note-link-label]');
    const seal = root.querySelector('.uh-note-pick svg');
    const card = root.querySelector('[data-uh-note-card]');
    const cardImage = root.querySelector('[data-uh-note-card-image]');
    const cardTitle = root.querySelector('[data-uh-note-card-title]');
    const cardPrice = root.querySelector('[data-uh-note-card-price]');
    const choices = [...document.querySelectorAll('[data-uh-house] [data-uh-panel]')].map(panel => ({
      name: panel.querySelector('.uh-collection-title')?.textContent.trim(),
      href: panel.querySelector('.uh-room-cta')?.getAttribute('href'),
      products: [...panel.querySelectorAll('.uh-mini-find')].map(item => {
        const image = item.querySelector('img');
        return {
          title: item.querySelector('.uh-mini-name')?.textContent.trim(),
          price: item.querySelector('.uh-mini-price')?.textContent.trim(),
          href: item.getAttribute('href'),
          image: image?.currentSrc || image?.src,
          srcset: image?.getAttribute('srcset')
        };
      }).filter(product => product.title && product.href && product.image)
    })).filter(choice => choice.name && choice.href && choice.products.length);
    let last = -1;
    let lastProduct = '';
    let frame = 0;
    let observer;
    let motionObserver;
    let inView = false;
    let flourish;
    let cardFlourish;
    root.dataset.uhNoteEnhanced = '';
    const syncMotion = () => root.classList.toggle('uh-note-motion-paused', reduced.matches || document.hidden || !inView || overlayOpen());
    document.addEventListener('visibilitychange', syncMotion, options);
    document.addEventListener('haven:overlay', syncMotion, options);
    reduced.addEventListener('change', syncMotion, options);
    if ('IntersectionObserver' in window) {
      motionObserver = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; syncMotion(); }, { threshold: .05 });
      motionObserver.observe(root.querySelector('.uh-note-seal') || root);
    } else inView = true;
    syncMotion();
    if (pick && choices.length) {
      pick.hidden = false;
      pick.addEventListener('click', () => {
        const next = choices.length > 1 && last >= 0 ? (last + 1 + Math.floor(Math.random() * (choices.length - 1))) % choices.length : Math.floor(Math.random() * choices.length);
        const choice = choices[next];
        last = next;
        if (find) find.textContent = find.dataset.template.replace('__room__', choice.name);
        if (link) link.href = choice.href;
        if (label && link) label.textContent = link.dataset.template.replace('__room__', choice.name);
        const alternatives = choice.products.filter(product => product.href !== lastProduct);
        const pool = alternatives.length ? alternatives : choice.products;
        const product = pool[Math.floor(Math.random() * pool.length)];
        if (card) {
          card.hidden = !product;
          cardFlourish?.cancel();
          if (product) {
            lastProduct = product.href;
            card.href = product.href;
            card.setAttribute('aria-label', card.dataset.template.replace('__product__', product.title));
            if (cardImage) {
              cardImage.src = product.image;
              cardImage.alt = product.title;
              cardImage.sizes = '112px';
              if (product.srcset) cardImage.srcset = product.srcset;
              else cardImage.removeAttribute('srcset');
            }
            if (cardTitle) cardTitle.textContent = product.title;
            if (cardPrice) cardPrice.textContent = product.price || '';
            if (!reduced.matches) cardFlourish = card.animate([{ opacity: .2, transform: 'translateY(14px) rotate(-1deg)' }, { opacity: 1, transform: 'translateY(0) rotate(0deg)' }], { duration: 650, easing: 'cubic-bezier(.22,1,.36,1)' });
          }
        }
        if (pickLabel) pickLabel.textContent = pick.dataset.again;
        pick.setAttribute('aria-label', pick.dataset.again);
        root.classList.add('uh-note-picked');
        flourish?.cancel();
        if (!reduced.matches) {
          flourish = seal?.animate([{ transform: 'rotate(0deg) scale(1)' }, { transform: 'rotate(150deg) scale(1.09)', offset: .55 }, { transform: 'rotate(180deg) scale(1)' }], { duration: 850, easing: 'cubic-bezier(.22,.65,.3,1)' });
          find?.animate([{ opacity: .1, transform: 'translateY(7px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 420, easing: 'ease-out' });
        }
      }, options);
    }
    const enter = () => root.classList.add('uh-note-entered');
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        enter();
        observer.disconnect();
      }, { threshold: .15 });
      observer.observe(root.querySelector('h2') || root);
    } else enter();
    root.addEventListener('pointermove', event => {
      if (!finePointer.matches || reduced.matches || event.pointerType !== 'mouse') return;
      if (frame) cancelAnimationFrame(frame);
      const rect = root.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width;
      const y = (event.clientY - rect.top) / rect.height;
      frame = requestAnimationFrame(() => {
        root.style.setProperty('--uh-note-x', (x * 100).toFixed(1) + '%');
        root.style.setProperty('--uh-note-y', (y * 100).toFixed(1) + '%');
        root.style.setProperty('--uh-paper-x', ((x - .5) * 9).toFixed(2) + 'px');
        root.style.setProperty('--seal-angle', ((x - .5) * 28).toFixed(1) + 'deg');
        frame = 0;
      });
    }, options);
    root.addEventListener('pointerleave', () => {
      if (frame) cancelAnimationFrame(frame);
      frame = 0;
      root.style.setProperty('--uh-paper-x', '0px');
      root.style.setProperty('--seal-angle', '0deg');
    }, options);
    notes.set(root, () => {
      controller.abort();
      stopFilm();
      observer?.disconnect();
      motionObserver?.disconnect();
      flourish?.cancel();
      cardFlourish?.cancel();
      if (frame) cancelAnimationFrame(frame);
      notes.delete(root);
    });
  }
  function init(scope = document) {
    if (scope.matches?.('[data-uh-house]')) initHouse(scope);
    scope.querySelectorAll('[data-uh-house]').forEach(initHouse);
    if (scope.matches?.('.uh-cabinet')) initCabinet(scope);
    scope.querySelectorAll('.uh-cabinet').forEach(initCabinet);
    if (scope.matches?.('[data-uh-note]')) initNote(scope);
    scope.querySelectorAll('[data-uh-note]').forEach(initNote);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
      [...houses, ...cabinets, ...notes].forEach(([root, cleanup]) => { if (event.target.contains(root)) cleanup(); });
  });
})();
